import { AppConfig } from './types';

declare global {
  interface Window {
    bentleyConfiguration: AppConfig;
  }
}

export const getEnvironmentName = () => {
  return window.bentleyConfiguration.environmentName;
};

export const getBuddiRegion = (): string => {
  return window.bentleyConfiguration.buddiRegion.toString();
};

export const getFeatureToggleConfig = () =>
  window.bentleyConfiguration.featureToggle;
